export default __webpack_public_path__ + "static/media/ic-underline.18a7023d.svg";